import classes from "../classes";
import expandable from "./higher-order/expandable";
import ButtonLink from "./button-link";
import { Link } from "react-router-dom";
import { List } from "immutable";
import pure from "./higher-order/pure";
import React from "react";
import tournamentTabs from "../tournament-tabs";

export default pure(expandable(function TournamentListTabs({ active, expanded, session, tags, toggle }) {
  var cx = classes({
    "tabs": true,
    "tabs--is-open": expanded
  });

  var tag = tags.valueSeq().find(t => t.get("name") === active);

  var tabElements = Object.keys(tournamentTabs)
    .filter(tab => hasAbility(tab, session.get("abilities")))
    .filter(tab => !tournamentTabs[tab].onlyShowOnTag)
    .map(tab => (
      <li
        className={classes({
          "tabs_tab": true,
          "tabs_tab--is-active": active === tab
        })}
        key={tab}>
        <Link className="tabs_link" onClick={toggle} to={"/tournaments/list/" + tab}>
          {tournamentTabs[tab].title}
        </Link>
      </li>
    ));

  return (
    <div className="tabs_wrapper">
      <ul className={cx}>
        <li className="tabs_tab tabs_tab--menu-label">
          <ButtonLink className="tabs_link" onClick={toggle}>
            {titleForList(active, tag)}
          </ButtonLink>
        </li>

        {tabElements}
      </ul>
    </div>
  );
}));

function titleForList(list, tag) {
  var tab = tournamentTabs[list];
  if (tab) {
    return tab.title;
  }
  if (tag) {
    return tag.get("title");
  }
  return null;
}

function hasAbility(tab, abilities = List()) {
  var tabInfo = tournamentTabs[tab];

  var neededAbilities = tabInfo.abilities;

  if (neededAbilities !== undefined && abilities.filter(n => neededAbilities.includes(n)).size !== neededAbilities.length) {
    return false;
  }

  var excludingAbilities = tabInfo.excludingAbilities;
  if (excludingAbilities !== undefined && abilities.filter(n => excludingAbilities.includes(n)).size !== excludingAbilities.length) {
    return false;
  }

  return true;
}
